import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {HouseholdService} from "../../../service/api/household.service";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";


@Component({
    selector: 'object-household-component',
    templateUrl: './object-household.component.html',
    standalone: false
})
export class ObjectHouseholdComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    householdWidget: WidgetData;
    householdPersonsWidget: WidgetData;

    constructor(protected coreService: MvsCoreService,
                protected messageService: MvsMessageService,
                protected confirmationService: ConfirmationService,
                protected observerService: ObserverService,
                protected householdService: HouseholdService) {
        super(coreService, messageService, confirmationService, observerService);
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    protected retrieveObject() {

        this.householdWidget = WidgetFactory.createWidgetListEntityBasicQl("object.household.household.widget.new", "Haushalt", "pm.Household", [FilterCriteria.create("e.id", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)]);

        this.householdPersonsWidget = WidgetFactory.createWidgetListEntityBasicQl("object.household.household.persons.widget.new", "Personen im Haushalt", "pm.HouseholdPerson", [FilterCriteria.create("e.householdId", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)]);

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'householdDtoId', fieldValue: this.objectIdentifier.objectId},];

        this.householdPersonsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;

    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
